<template>
  <el-dialog class="select-service-modal" title="选择服务项目" :visible.sync="visible" width="1200px">
    <div class="content" v-loading="loading">
      <div class="header">
        <div class="field">
          <div class="label">服务商</div>
          <div class="ctrl">
            <el-select size="mini" v-model="search.providerGid" clearable>
              <el-option
                v-for="item in providers"
                :key="item.gid"
                :label="item.providerName"
                :value="item.gid"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="field">
          <div class="label">服务类别</div>
          <div class="ctrl">
            <el-cascader
              size="mini"
              v-model="search.type"
              :options="typeData"
              :props="typeProps"
              clearable
            ></el-cascader>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="table-wrapper">
          <el-table :data="list" stripe style="width: 100%" height="100%">
            <el-table-column prop="index" label="#" align="center" width="60"></el-table-column>
            <el-table-column prop="childrenCategory" label="服务类型" align="center" width="120"></el-table-column>
            <el-table-column prop="serviceName" label="服务项目名称"></el-table-column>
            <el-table-column prop="providerName" label="服务商"></el-table-column>
            <el-table-column label="服务时长">
              <template
                slot-scope="scope"
              >{{scope.row.unitFrequencyTime}}{{getNameOfUnitTime(scope.row.unitOfTime)}}</template>
            </el-table-column>
            <el-table-column label="服务时段" align="center" width="200">
              <template
                slot-scope="scope"
              >{{scope.row.servicePeriod ? scope.row.servicePeriod.replace(',', '-') : '不限时段'}}</template>
            </el-table-column>
            <el-table-column label="服务周期" prop="cycle" align="center">
              <template slot-scope="scope">{{scope.row.cycle|cycleFilter}}</template>
            </el-table-column>
            <el-table-column label="服务次数" prop="frequency" align="center">
              <template slot-scope="scope">{{scope.row.frequency}}</template>
            </el-table-column>
            <el-table-column prop="price" label="价格" align="center" width="100"></el-table-column>
            <el-table-column prop="operation" label="操作" fixed="right" width="80">
              <template slot-scope="scope">
                <el-button type="text" @click="select(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-pagination
        @size-change="handleSizeChange($event)"
        @current-change="handleCurrentChange($event)"
        :current-page="pagination.index "
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import ModalMixin from '@/libs/modal/modal-mixin'

export default {
  mixins: [ModalMixin],
  data() {
    return {
      providers: [],
      search: {
        providerGid: null,
        type: []
      },
      serviceTypesProps: {},
      typeProps: {
        label: "Name",
        children: "children",
        value: "Gid"
      },
      typeData: [],
      pagination: {
        index: 1,
        total: 0,
        size: 10
      },
      list: [],
      loading: false,
      theOldGid:this.$route.query.oneOldGid || ''
    }
  },
  created() {
    let vm = this;
    
    let service = this.Service

    this.Service.call('ServiceCategory', 'GET', { index: 0, size: 1000 }).then(data => {
      let arr = data.Data
      let endArr = new Array()
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].Remark === "0") {
          endArr.push(arr[i])
        }
      }
      let temp = vm.buildTree(endArr)
      endArr = temp
      this.typeData = endArr
    })
  },
  methods: {
    buildTree(list) {
      let temp = {};
      let tree = [];
      for (let i in list) {
        temp[list[i].Gid] = list[i];
      }
      for (let i in temp) {
        if (temp[i].ParentId) {
          if (!temp[temp[i].ParentId].children) {
            temp[temp[i].ParentId].children = new Array();
          }
          temp[temp[i].ParentId].children.push(temp[i]);
        } else {
          tree.push(temp[i]);
        }
      }
      return tree;
    },
    init(theOldGid) {
      this.theOldGid = theOldGid ? theOldGid : this.theOldGid;
      this.Service.call('serviceprovider/bylocation', 'GET', { index: 0, size: 1000, type: 1 ,theOldGid:this.theOldGid}).then(data => {
        this.providers = data && data.data || []
        this.loadData()
      });
      return this.open()
    },
    handleSizeChange(i) {
      this.pagination.size = i
      this.pagination.index = 1
      this.loadData()
    },
    handleCurrentChange(i) {
      this.pagination.index = i
      this.loadData()
    },
    loadData() {
      this.loading = true
      let query = { index: this.pagination.index - 1, size: this.pagination.size, serviceProviderType: 1 }
      if (this.search.providerGid) {
        query.serviceprovidergid = this.search.providerGid
      }
      if (this.search.type && this.search.type.length > 1) {
        query.servicecategorygid = this.search.type[1]
      }
      this.Service.call('serviceitem', 'GET', query).then(data => {
        let providers = this.providers
        data.data = _.filter(data.data, function(o) { return _.find(providers ,e => e.gid == o.providerId)});
        _.forEach(data.data, (item, idx) => {
          item.index = data.index * data.size + idx + 1
        })
        this.list = data.data || []
        this.pagination = {
          index: data.index + 1,
          size: data.size,
          total: data.total
        }
      }).finally(() => {
        this.loading = false
      })
      
    },
    select(row) {
      this.close(row)
    }
  },
  watch: {
    'search.type'() {
      this.loadData()
    },
    'search.providerGid'() {
      this.loadData()
    }
  }
}
</script>
